export default "__VITE_ASSET__CWeV4EOd__"